import { lazy, useEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import { VM } from '../VM';

import { Index as ToolCategories } from '../../__personal/components/toolcategories/Index';
import { RenderAPI } from '../../__personal/components/global/RenderAPI';
import { Switching } from '../../__personal/components/swtiching/Index'
import { Settings } from '../../__personal/components/settings/Index';
import { Personalization } from '../../__personal/components/personalization/Index';

//Maintenance 
// import { Maintenance } from '../../__personal/components/maintenance/Index';

let view = VM();
const Navigation = lazy(() => import(`../../__personal/components/layouts/navigations${view}/Index`))
const Home = lazy(() => import (`../../__personal/components/home${view}/Index`))
const Welcome = lazy(() => import(`../../__personal/components/home${view}/welcome/Index`))

// TRAININGS COMPONENTS
const Trainings = lazy(() => import(`../../__personal/components/trainings${view}/Index`))
const TrainingSearch = lazy(() => import(`../../__personal/components/trainings${view}/search/Index`))
const Exclusive = lazy(() => import(`../../__personal/components/trainings${view}/exclusive/Index`))

// PROFILE COMPOENENTS
const Personal = lazy(() => import(`../../__personal/components/personal${view}/Index`))
const Profile = lazy(() => import(`../../__personal/components/profile${view}/Index`))
const Profiling = lazy(() => import(`../../__personal/components/profile${view}/firstSetup/Index`))
const FirstSetup = lazy(() => import(`../../__personal/components/profile${view}/firstSetup/form/Index`))
const EmailSetup = lazy(() => import(`../../__personal/components/profile${view}/form/emailSetup/Index`))

const Profession = lazy(() => import(`../../__personal/components/profession${view}/Index`))

// CERTIFICATES COMPONENTS
const Certificates = lazy(() => import(`../../__personal/components/certificates${view}/Index`))
const RecentlyRemoved = lazy(() => import(`../../__personal/components/certificates${view}/removed/Index`))
const CertificateSearch = lazy(() => import(`../../__personal/components/certificates${view}/search/Index`))

const Courses = lazy(() => import(`../../__personal/components/courses${view}/Index`))

// PREVIEW
// const Preview = lazy(() => import(`../../__personal/components/trainings/devices/mobile/preview/Index`))
const Preview = lazy(() => import(`../../__personal/components/preview${view}/Index`))

// TAKE TRAINING COURSE
const Take = lazy(() => import(`../../__personal/components/take${view}/Index`))
const TakeCourse = lazy(() => import(`../../__personal/components/takecourse${view}/Index`))
// UBR

export const WebRoute = ({personalization_state, training_state, tool_state}) => {
    const location = useLocation().pathname;
    const mnt = tool_state.mnt.data
    let q = new URLSearchParams(window.location.search);

    const { onboarding } = {...personalization_state, ...training_state}

    useEffect(() => {
        const loc = location.split('/')[1]
        
        if (view === '') {
            return

        } else {
            if (onboarding.data.profiling) {
                if (loc !== 'profile') window.location.href = '/profile/first-setup'
                if (location === '/profile') window.location.href = '/profile/first-setup'
                return
            }

            if (onboarding.data.welcome.stat) {
                if (loc !== 'welcome') {
                    window.location.href = '/welcome'
                }
                return
            }
        }


		// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <Switch>
            {/* HOME */}
            <Route exact path="/" render={props=>(Render(Home, props, location, mnt))}/>
            <Route exact path="/switching/:params" render={props=><Switching {...props}/>} />
            <Route exact path="/more" render={props=>(Render(Settings, props, location, mnt))} />
            <Route exact path="/tool-categories/:params" render={props=>(Render(ToolCategories, props, location, mnt))} />

            {/* PROFILE ROUTES */}
            <Route exact path="/personal/info" render={props=>(Render(Personal, props, location, mnt , q))} />
            <Route exact path="/profile" render={props=>(Render(Profile, props, location, mnt , q))} />
            <Route exact path="/profile/email-setup" render={props=>(Render(EmailSetup, props, location, mnt, q))} />

            {/* WELCOME ONBOARDING ROUTES */}
            <Route exact path="/profile/first-setup" render={props=>(Render(Profiling, props, location, mnt, q))} />
            <Route exact path="/profile/first-setup/form" render={props=>(Render(FirstSetup, props, location, mnt, q))} />
            <Route exact path="/welcome" render={props=>(Render(Welcome, props, location, mnt, q))} />

            {/* Profession ROUTES */}
            <Route exact path="/professional" render={props=>(Render(Profession, props, location))} />

            {/* TRAINING ROUTES */}
            <Route exact path="/trainings/:tab" render={props=>(Render(Trainings, props, location, mnt))} />
            <Route exact path="/trainings/list/search" render={props=>(Render(TrainingSearch, props, location, mnt))} />
            <Route exact path="/trainings/list/exclusive" render={props=>(Render(Exclusive, props, location, mnt))} />

            {/* CERTIFICATES ROUTES */}
            <Route exact path="/certificates/:tab" render={props=>(Render(Certificates, props, location, mnt))} />
            <Route exact path="/certificates/recently/removed" render={props=>(Render(RecentlyRemoved, props, location, mnt))} />
            <Route exact path="/certificates/list/search" render={props=>(Render(CertificateSearch, props, location, mnt))} />

            {/* COURES PAGE */}
            <Route exact path="/courses/:tab" render={props=>(Render(Courses, props, location, mnt))} />

            {/* QUIZ */}
            <Route exact path="/tool-categories/:tab" render={props=>(Render(ToolCategories, props, location, mnt))} />

            {/* PREVIEW */}
            <Route exact path="/preview" render={props=>(Render(Preview, props, location, mnt))} />

            {/* TAKE TRAINING COURSE */}
            <Route exact path="/take-training-course/:tab" render={props=>(Render(Take, props, location, mnt))} />
            <Route exact path="/take-course/:tab" render={props=>(Render(TakeCourse, props, location, mnt))} />


            {/* 404 NOT FOUND */}
            <Route>
                <Container>
                    <Box display="flex">
                        Error 404
                    </Box>
                </Container>
            </Route>
        </Switch>
    )
}

const Render = (Component, props, location, mnt, q) => (
    
    <>
        {view === '' ? (
            <Box width="100%" height="100%">
                <Box width="100%" height="100%" display="flex">
                    <Box height="100%">
                        { !(location === '/profile' && q.get('account') !== null) && (location !== '/profiling') && ( location !== '/take-training-course/pretest' && location !== '/take-training-course/quiz' && location !== '/take-training-course/video-lesson' && location !== '/take-training-course/post-evaluation') && ( location !== '/take-course/pretest' && location !== '/take-course/quiz' && location !== '/take-course/video-lesson' && location !== '/take-course/post-evaluation') && (<Navigation side={1} />)}
                    </Box>
                    <Box display="flex" flexDirection="column" width="100%" height="100%">
                        <Navigation side={0} />
                        <Box height="100%" className="overflowY noScrollcss">
                            {/* {
                                mnt === true ? (
									<Maintenance />
                                ) : ( 
                                    <Component {...props} />
                                    )
                            } */}
                            <Component {...props} />
                        </Box>
                    </Box>
                </Box>
                <Personalization />
            </Box>
        ) : (
            <Box width="100%" height="100%">
                <Box width="100%" height="100%" display="flex" flexDirection="column">
                    {(location !== '/profile/first-setup' && location !== '/profile/first-setup/form' && location !== '/welcome' && location !== '/profiling' && location !== '/more' && location !== '/certificates/recently/removed') && (
                        <Box minHeight={location === '/' ? '92px' : '40px'}>
                            <Navigation side={0} />
                        </Box>
                    )}
                    <Box height="100%" width="100%" className="overflowY noScrollcss">
                        {/* {
                            mnt === true ? (
                                <Maintenance />
                            ) : ( 
                                <Component {...props} />
                                )
                        } */}
                        <Component {...props} />
                    </Box>
                    {(location !== '/profile/first-setup' && location !== '/profile/first-setup/form' && location !== '/welcome' && location !== '/profiling' && location !== '/certificates/recently/removed') &&
                        <Box minHeight="54px">
                            <Navigation side={2} />
                        </Box>
                    } 
                </Box>
            </Box>
        )}
        <RenderAPI/>
    </>
)